export default "__VITE_ASSET__21fcd4ab__"